$(document).ready(function() {
    $(document).on('click',
        '#dropdown-select-target .dropdown-menu',
        function(e) {
            e.stopPropagation();
        }
    );

    let $input = $('#dropdown-select'),
        $checkbox = $('input[id^=categoria]');

    $checkbox.on('change', function() {
        let seleccion = $('input[id^=categoria]:checked').map(
            function() {
                return $(this).next('label').html();
            }
        );
        if (seleccion.length > 2) {
            seleccion = `${seleccion.length} categorías`;
        } else {
            seleccion = seleccion.get().join(', ');
        }
        $input.val(seleccion);
    });
});
